import { ModelSagres } from "../../model-sagres";

export class TipoAnexo extends ModelSagres {
    IdTipoAnexo: number;
    DsTipoAnexo: string;
    FlObrigatorio: boolean;
    FlPermiteMultiplos: boolean;
    NrOrdem: number | null;
    DsTipoEdital: string | null;
    TpGrupoAnexo: 'CAD' | 'PUB' | 'HML' | 'PRO' | string;
    DtInicioVigencia: string | null;
    DtFimVigencia: string | null;

    constructor(obj?: any) {
        super();
        if (obj) {
            this.IdTipoAnexo = obj.IdTipoAnexo;
            this.DsTipoAnexo = obj.DsTipoAnexo;
            this.FlObrigatorio = obj.FlObrigatorio;
            this.FlPermiteMultiplos = obj.FlPermiteMultiplos;
            this.NrOrdem = obj.NrOrdem ?? null;
            this.DsTipoEdital = obj.DsTipoEdital ?? null;
            this.TpGrupoAnexo = obj.TpGrupoAnexo;
            this.DtInicioVigencia = obj.DtInicioVigencia ?? null;
            this.DtFimVigencia = obj.DtFimVigencia ?? null;
        }
    }
}